import type { ProductConfCols } from '@eliadmin/core/src/api/proform/proform-types';
import { Label } from '@eliadmin/core/src/components/ui/label';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@eliadmin/core/src/components/ui/tooltip';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { TooltipPortal } from '@radix-ui/react-tooltip';
import { RiInformationFill } from 'react-icons/ri';

type ConfiguratorFieldLabelProps = {
  fieldConfig: ProductConfCols['root']['smako_conf_cols']['column'][number];
  isInvalid?: boolean;
};

export function ConfiguratorFieldLabel({
  fieldConfig: fieldCol,
  isInvalid,
}: ConfiguratorFieldLabelProps) {
  return (
    <div className="flex items-center justify-start gap-1">
      {!!fieldCol.help && (
        <TooltipProvider>
          <Tooltip delayDuration={100}>
            <TooltipTrigger>
              <RiInformationFill className="h-5 w-5 text-accent transition" />
            </TooltipTrigger>
            <TooltipPortal>
              <TooltipContent
                sideOffset={10}
                className="max-w-[250px] rounded-lg border bg-secondary p-4 text-muted-foreground"
              >
                {fieldCol.help}
              </TooltipContent>
            </TooltipPortal>
          </Tooltip>
        </TooltipProvider>
      )}
      <Label
        className={cn(
          'line-clamp-1 text-left text-sm text-muted-foreground',
          isInvalid && 'text-destructive',
        )}
        htmlFor={fieldCol.column}
      >
        {fieldCol.label}
      </Label>
    </div>
  );
}
